import { LoadingScreen as InternalLoadingScreen } from "@vetty/internal-ui";
import type { ComponentProps } from "react";

export const LoadingScreen = (
  props: ComponentProps<typeof InternalLoadingScreen>,
) => (
  <InternalLoadingScreen {...props} logoSrc="/assets/brandmark-dark.svg" />
);
